module.exports = __webpack_public_path__ + "img/product-landscape-cocoa-ball-x2.5eadacbd.jpg";